import { IDictionary } from 'models/dictionary';

type Address = {
  line1?: string;
  line2?: string;
  postalCode?: string;
  city?: string;
  countryUniqueId?: string;
};

const getCountryName = (countryId: any, country: IDictionary[] | null) => {
  if (!countryId) return '';
  const countryFromDictionary = country
    ? country.filter((item) => item.uniqueId === countryId)
    : null;
  if (countryFromDictionary && countryFromDictionary.length) {
    return countryFromDictionary[0].name;
  }
  return '';
};

export function formatAddress(
  address: Address | null | undefined,
  countryDictionary: IDictionary[] | null,
): string | null {
  if (!address || !address.line1 || !address.city) {
    return null;
  }

  const { line1, line2, postalCode, city, countryUniqueId } = address;

  const countryName = getCountryName(countryUniqueId, countryDictionary);

  return `${line1}${line2 ? ` ${line2}` : ''}, ${postalCode} ${city}, ${countryName}`;
}
